export const DRIVEIP = [
    {
        "ip": "10.36.1.220",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.84\"}"
    },
    {
        "ip": "10.36.1.222",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.71\"}"
    },
    {
        "ip": "10.36.1.223",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.34\"}"
    },
    {
        "ip": "10.36.1.226",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.73\"}"
    },
    {
        "ip": "10.36.1.227",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.30\"}"
    },
    {
        "ip": "10.36.1.229",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.41\"}"
    },
    {
        "ip": "10.36.1.230",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.29\"}"
    },
    {
        "ip": "10.36.1.232",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.51\"}"
    },
    {
        "ip": "10.36.1.233",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.135\"}"
    },
    {
        "ip": "10.36.1.235",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.113\"}"
    },
    {
        "ip": "10.36.1.238",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.95\"}"
    },
    {
        "ip": "10.36.2.112",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.112\", \"model\": \"ME4-2450RE2\"}"
    },
    {
        "ip": "10.36.2.113",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.115",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.115\", \"model\": \"ME4-2450RE2\"}"
    },
    {
        "ip": "10.36.2.117",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"JR3-52\"}"
    },
    {
        "ip": "10.36.2.119",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.119\", \"model\": \"ME4-2450RE2\"}"
    },
    {
        "ip": "10.36.2.122",
        "anotacion": null
    },
    {
        "ip": "10.36.2.124",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"JR3-52\"}"
    },
    {
        "ip": "10.36.2.130",
        "anotacion": null
    },
    {
        "ip": "10.36.2.131",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.137\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.132",
        "anotacion": null
    },
    {
        "ip": "10.36.2.133",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.139\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.134",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.140\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.135",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.141\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.136",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.142\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.137",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.143\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.138",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.144\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.14",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.12\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.143",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2450\"}"
    },
    {
        "ip": "10.36.2.144",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.122\", \"model\": \"ES1-2450RE\"}"
    },
    {
        "ip": "10.36.2.145",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2450\"}"
    },
    {
        "ip": "10.36.2.146",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.121\", \"model\": \"ES1-2450RE\"}"
    },
    {
        "ip": "10.36.2.147",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2450\"}"
    },
    {
        "ip": "10.36.2.195",
        "anotacion": null
    },
    {
        "ip": "10.36.2.203",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"JR3-52\"}"
    },
    {
        "ip": "10.36.2.211",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.212",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.222",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.34",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.32\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.4",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.2\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.53",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.51\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.54",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.52\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.58",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.56\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.65",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.63\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.68",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.66\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.69",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.67\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.70",
        "anotacion": "{\"modo\": \"heatmap\"}"
    },
    {
        "ip": "10.36.2.71",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.69\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.73",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.71\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.84",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.82\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.2.9",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.5.7\", \"model\": \"ME5-2450CS\"}"
    },
    {
        "ip": "10.36.4.1",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.10",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.11",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.12",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.13",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.14",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.141",
        "anotacion": null
    },
    {
        "ip": "10.36.4.142",
        "anotacion": null
    },
    {
        "ip": "10.36.4.143",
        "anotacion": null
    },
    {
        "ip": "10.36.4.144",
        "anotacion": null
    },
    {
        "ip": "10.36.4.145",
        "anotacion": null
    },
    {
        "ip": "10.36.4.146",
        "anotacion": null
    },
    {
        "ip": "10.36.4.147",
        "anotacion": null
    },
    {
        "ip": "10.36.4.148",
        "anotacion": null
    },
    {
        "ip": "10.36.4.15",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.156",
        "anotacion": "{\"gps\": \"10.36.4.1\"}"
    },
    {
        "ip": "10.36.4.157",
        "anotacion": "{\"gps\": \"10.36.4.3\"}"
    },
    {
        "ip": "10.36.4.158",
        "anotacion": "{\"gps\": \"10.36.4.4\"}"
    },
    {
        "ip": "10.36.4.159",
        "anotacion": "{\"gps\": \"10.36.4.5\"}"
    },
    {
        "ip": "10.36.4.16",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.160",
        "anotacion": "{\"gps\": \"10.36.4.6\"}"
    },
    {
        "ip": "10.36.4.161",
        "anotacion": "{\"gps\": \"10.36.4.7\"}"
    },
    {
        "ip": "10.36.4.162",
        "anotacion": "{\"gps\": \"10.36.4.8\"}"
    },
    {
        "ip": "10.36.4.164",
        "anotacion": "{\"gps\": \"10.36.4.10\"}"
    },
    {
        "ip": "10.36.4.167",
        "anotacion": "{\"gps\": \"10.36.4.13\"}"
    },
    {
        "ip": "10.36.4.168",
        "anotacion": "{\"gps\": \"10.36.4.14\"}"
    },
    {
        "ip": "10.36.4.17",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.170",
        "anotacion": "{\"gps\": \"10.36.4.16\"}"
    },
    {
        "ip": "10.36.4.171",
        "anotacion": "{\"gps\": \"10.36.4.17\"}"
    },
    {
        "ip": "10.36.4.172",
        "anotacion": "{\"gps\": \"10.36.4.18\"}"
    },
    {
        "ip": "10.36.4.173",
        "anotacion": "{\"gps\": \"10.36.4.19\"}"
    },
    {
        "ip": "10.36.4.174",
        "anotacion": "{\"gps\": \"10.36.4.20\"}"
    },
    {
        "ip": "10.36.4.175",
        "anotacion": "{\"gps\": \"10.36.4.21\"}"
    },
    {
        "ip": "10.36.4.18",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.181",
        "anotacion": "{\"gps\": \"10.36.4.42\"}"
    },
    {
        "ip": "10.36.4.183",
        "anotacion": "{\"gps\": \"10.36.4.44\"}"
    },
    {
        "ip": "10.36.4.184",
        "anotacion": "{\"gps\": \"10.36.4.45\"}"
    },
    {
        "ip": "10.36.4.185",
        "anotacion": "{\"gps\": \"10.36.4.46\"}"
    },
    {
        "ip": "10.36.4.188",
        "anotacion": "{\"gps\": \"10.36.4.49\"}"
    },
    {
        "ip": "10.36.4.189",
        "anotacion": null
    },
    {
        "ip": "10.36.4.19",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.190",
        "anotacion": "{\"gps\": \"10.36.4.51\"}"
    },
    {
        "ip": "10.36.4.193",
        "anotacion": "{\"gps\": \"10.36.4.54\"}"
    },
    {
        "ip": "10.36.4.194",
        "anotacion": "{\"gps\": \"10.36.4.55\"}"
    },
    {
        "ip": "10.36.4.197",
        "anotacion": "{\"gps\": \"10.36.4.58\"}"
    },
    {
        "ip": "10.36.4.2",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.20",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.200",
        "anotacion": "{\"gps\": \"10.36.4.61\"}"
    },
    {
        "ip": "10.36.4.201",
        "anotacion": "{\"gps\": \"10.36.4.62\"}"
    },
    {
        "ip": "10.36.4.202",
        "anotacion": "{\"gps\": \"10.36.4.63\"}"
    },
    {
        "ip": "10.36.4.203",
        "anotacion": "{\"gps\": \"10.36.4.64\"}"
    },
    {
        "ip": "10.36.4.204",
        "anotacion": "{\"gps\": \"10.36.4.65\"}"
    },
    {
        "ip": "10.36.4.205",
        "anotacion": "{\"gps\": \"10.36.4.66\"}"
    },
    {
        "ip": "10.36.4.206",
        "anotacion": "{\"gps\": \"10.36.4.67\"}"
    },
    {
        "ip": "10.36.4.208",
        "anotacion": "{\"gps\": \"10.36.4.69\"}"
    },
    {
        "ip": "10.36.4.209",
        "anotacion": "{\"gps\": \"10.36.4.70\"}"
    },
    {
        "ip": "10.36.4.21",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.210",
        "anotacion": "{\"gps\": \"10.36.4.71\"}"
    },
    {
        "ip": "10.36.4.22",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.229",
        "anotacion": null
    },
    {
        "ip": "10.36.4.23",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.230",
        "anotacion": null
    },
    {
        "ip": "10.36.4.232",
        "anotacion": null
    },
    {
        "ip": "10.36.4.233",
        "anotacion": null
    },
    {
        "ip": "10.36.4.24",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.25",
        "anotacion": null
    },
    {
        "ip": "10.36.4.252",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.2.71\"}"
    },
    {
        "ip": "10.36.4.27",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.28",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.29",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.3",
        "anotacion": null
    },
    {
        "ip": "10.36.4.30",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.31",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.32",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.33",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.34",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.35",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.36",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"10.36.4.136\", \"model\": \"ME4-2450RE2\"}"
    },
    {
        "ip": "10.36.4.37",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.38",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.39",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"9.9.9.9\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.4",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.40",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.41",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.42",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.43",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.44",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.45",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.46",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.47",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.48",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.49",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.5",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.50",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.51",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.52",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.53",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"LX5-2255C\"}"
    },
    {
        "ip": "10.36.4.54",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.55",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.56",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.57",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.58",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.59",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.6",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.60",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.61",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.62",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.63",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.64",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.65",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.66",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.67",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.68",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.69",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.7",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.70",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2255B\"}"
    },
    {
        "ip": "10.36.4.71",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.72",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.73",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.74",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.75",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.8",
        "anotacion": "{\"server_bcapi\": \"10.36.4.47\", \"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    },
    {
        "ip": "10.36.4.9",
        "anotacion": "{\"modo\": \"heatmap\", \"gps\": \"\", \"model\": \"FE1-2455LW\"}"
    }
]

export const DRIVEEQUIP = [
    {
        "ip": "10.36.2.112",
        "name": "RD040-HORNET"
    },
    {
        "ip": "10.36.2.113",
        "name": "RD041-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.115",
        "name": "RD045-HORNET"
    },
    {
        "ip": "10.36.2.117",
        "name": "RD047-JR3-2.4-CH-ONCE"
    },
    {
        "ip": "10.36.2.119",
        "name": "RD049-HORNET"
    },
    {
        "ip": "10.36.2.124",
        "name": "RD056-JR3-2.4-CH-ONCE"
    },
    {
        "ip": "10.36.2.130",
        "name": "TT047-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.131",
        "name": "TT048-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.132",
        "name": "TT049-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.133",
        "name": "TT050-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.134",
        "name": "TT051-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.135",
        "name": "TT052-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.136",
        "name": "TT054-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.137",
        "name": "TT056-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.138",
        "name": "TT057-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.14",
        "name": "DT612-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.143",
        "name": "MT036-HWK-FRONT LOADER"
    },
    {
        "ip": "10.36.2.144",
        "name": "MT059-OSP-FRONT LOADER"
    },
    {
        "ip": "10.36.2.145",
        "name": "MT061-HWK-FRONT LOADER"
    },
    {
        "ip": "10.36.2.146",
        "name": "MT062-OSP-FRONT LOADER"
    },
    {
        "ip": "10.36.2.147",
        "name": "MT088-HWK-FRONT LOADER"
    },
    {
        "ip": "10.36.2.195",
        "name": "MV096-JR3-2.4-CH-ONCE"
    },
    {
        "ip": "10.36.2.203",
        "name": "MV113-JR3-2.4-CH-ONCE"
    },
    {
        "ip": "10.36.2.211",
        "name": "MV130-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.212",
        "name": "MV131-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.222",
        "name": "MX033-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.34",
        "name": "DT632-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.4",
        "name": "DT602-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.53",
        "name": "DT651-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.54",
        "name": "DT652-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.58",
        "name": "DT656-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.65",
        "name": "DT663-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.68",
        "name": "DT666-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.69",
        "name": "DT667-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.70",
        "name": "DT668-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.71",
        "name": "DT669-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.73",
        "name": "DT671-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.84",
        "name": "DT682-ME5(SPARROW)"
    },
    {
        "ip": "10.36.2.9",
        "name": "DT607-ME5(SPARROW)"
    },
    {
        "ip": "10.36.4.1",
        "name": "101-LX5-RANCH-SUR1-ROOT"
    },
    {
        "ip": "10.36.4.10",
        "name": "110-PRGLTE-INC12-ROOT"
    },
    {
        "ip": "10.36.4.11",
        "name": "111-LX5-PNT-VLDR"
    },
    {
        "ip": "10.36.4.12",
        "name": "112-PRG-RAMPA-PR3"
    },
    {
        "ip": "10.36.4.13",
        "name": "113-PRGLTE-DEM-ROOT"
    },
    {
        "ip": "10.36.4.14",
        "name": "114-PRGLTE-EST-DEM-ROOT"
    },
    {
        "ip": "10.36.4.15",
        "name": "115-LX5-INC8-ALTO"
    },
    {
        "ip": "10.36.4.16",
        "name": "116-PRGLTE-PR2-OESTE-ROOT"
    },
    {
        "ip": "10.36.4.17",
        "name": "117-PRGLTE-INC9-ROOT"
    },
    {
        "ip": "10.36.4.18",
        "name": "118-PRGLTE-INC9-ROOT"
    },
    {
        "ip": "10.36.4.19",
        "name": "119-PRGLTE-OF.QLIX2-ROOT"
    },
    {
        "ip": "10.36.4.2",
        "name": "102-PRG-TORRE CONTROL-ROOT"
    },
    {
        "ip": "10.36.4.20",
        "name": "120-LX5-INC11-4-ROOT"
    },
    {
        "ip": "10.36.4.21",
        "name": "121-PRGLTE-INC9-ROOT"
    },
    {
        "ip": "10.36.4.22",
        "name": "122-PRGLTE-VAC-MX-TEPE"
    },
    {
        "ip": "10.36.4.23",
        "name": "123-LX5-ES023"
    },
    {
        "ip": "10.36.4.24",
        "name": "124-LX5-ES024"
    },
    {
        "ip": "10.36.4.25",
        "name": "125-LX5-ES025"
    },
    {
        "ip": "10.36.4.27",
        "name": "127-LX5-ES027"
    },
    {
        "ip": "10.36.4.28",
        "name": "128-LX5-ES028"
    },
    {
        "ip": "10.36.4.29",
        "name": "129-LX5-ES029"
    },
    {
        "ip": "10.36.4.3",
        "name": "103-LX5-DEM-QBLIX3-ROOT"
    },
    {
        "ip": "10.36.4.30",
        "name": "130-LX5-ES030"
    },
    {
        "ip": "10.36.4.31",
        "name": "131-LX5-ES031"
    },
    {
        "ip": "10.36.4.32",
        "name": "132-LX5-ES032"
    },
    {
        "ip": "10.36.4.33",
        "name": "133-LX5-ES033"
    },
    {
        "ip": "10.36.4.34",
        "name": "134-LX5-ES034"
    },
    {
        "ip": "10.36.4.35",
        "name": "135-LX5-ES035"
    },
    {
        "ip": "10.36.4.36",
        "name": "136-HNT-ES036"
    },
    {
        "ip": "10.36.4.37",
        "name": "137-LX5-ES037"
    },
    {
        "ip": "10.36.4.38",
        "name": "138-LX5-ES038"
    },
    {
        "ip": "10.36.4.39",
        "name": "139-LX5-ES039"
    },
    {
        "ip": "10.36.4.4",
        "name": "104-PRG-INC8-ROOT"
    },
    {
        "ip": "10.36.4.40",
        "name": "140-PRG-TNQS-ROOT"
    },
    {
        "ip": "10.36.4.41",
        "name": "141-PRG-BUENA-V-ROOT"
    },
    {
        "ip": "10.36.4.42",
        "name": "142-LX5-RAMPA-INC8-ROOT"
    },
    {
        "ip": "10.36.4.43",
        "name": "143-PRG-SUPCIA-MNT-ROOT"
    },
    {
        "ip": "10.36.4.44",
        "name": "144-PRG-INC-12-ROOT"
    },
    {
        "ip": "10.36.4.45",
        "name": "145-PRGLTE-RAMPA-INC16-ROOT"
    },
    {
        "ip": "10.36.4.46",
        "name": "146-LX5-INC9-1-ROOT"
    },
    {
        "ip": "10.36.4.47",
        "name": "147-PRG-PR2-MASTER-ROOT"
    },
    {
        "ip": "10.36.4.48",
        "name": "148-PRG-VAC-MX-TEPE"
    },
    {
        "ip": "10.36.4.49",
        "name": "149-PRGLTE-CURVA-VAC-MX-ROOT"
    },
    {
        "ip": "10.36.4.5",
        "name": "105-PRGLTE-MIRADOR-ROOT"
    },
    {
        "ip": "10.36.4.50",
        "name": "150-PRGLTE-INC-16-ROOT"
    },
    {
        "ip": "10.36.4.51",
        "name": "151-PRG-INC9-RAMPA-ASERRADERO-ROOT"
    },
    {
        "ip": "10.36.4.52",
        "name": "152-LX5-INC8-SITIO BOMBEO"
    },
    {
        "ip": "10.36.4.53",
        "name": "153-LX5-INC8-3"
    },
    {
        "ip": "10.36.4.54",
        "name": "154-PRG-INC11-RPA-QBLIX3-ROOT"
    },
    {
        "ip": "10.36.4.55",
        "name": "155-PRG-INC8-CURVA-LLANTAS-ROOT"
    },
    {
        "ip": "10.36.4.56",
        "name": "156-PRG-VAC-MX -2"
    },
    {
        "ip": "10.36.4.57",
        "name": "157-PRG-RAMPA-ASERRADERO"
    },
    {
        "ip": "10.36.4.58",
        "name": "158-PRG-INC12-ROOT"
    },
    {
        "ip": "10.36.4.59",
        "name": "159-PRG-INC11"
    },
    {
        "ip": "10.36.4.6",
        "name": "106-PRGLTE-ESPLANADA-GLUYAS-ROOT"
    },
    {
        "ip": "10.36.4.60",
        "name": "160-PRG-VAC-MX-3"
    },
    {
        "ip": "10.36.4.61",
        "name": "161-PRG-INC9-ROOT"
    },
    {
        "ip": "10.36.4.62",
        "name": "162-PRG-INC11-ROOT"
    },
    {
        "ip": "10.36.4.63",
        "name": "163-PRG-TALLERES-VIEJOS-ROOT "
    },
    {
        "ip": "10.36.4.64",
        "name": "164-PRG-INC12-ROOT"
    },
    {
        "ip": "10.36.4.65",
        "name": "165-PRG-INC12-QLIX2-ROOT"
    },
    {
        "ip": "10.36.4.66",
        "name": "166-PRGLTE-INC12-ROOT"
    },
    {
        "ip": "10.36.4.67",
        "name": "167-PRGLTE-INC9-ROOT"
    },
    {
        "ip": "10.36.4.68",
        "name": "168-PRGLTE-INC8-BAJO"
    },
    {
        "ip": "10.36.4.69",
        "name": "169-PRGLTE-INC9-ROOT"
    },
    {
        "ip": "10.36.4.7",
        "name": "107-PRG-CARCAMO-ROOT"
    },
    {
        "ip": "10.36.4.70",
        "name": "170-PRG-RAMPA-DEMOC-N-ROOT"
    },
    {
        "ip": "10.36.4.71",
        "name": "171-PRGLTE-COMEDOR3-ROOT"
    },
    {
        "ip": "10.36.4.72",
        "name": "172-PRGLTE-RUTA-MX"
    },
    {
        "ip": "10.36.4.73",
        "name": "173-PRGLTE-INC9"
    },
    {
        "ip": "10.36.4.74",
        "name": "174-PRGLTE-INC12"
    },
    {
        "ip": "10.36.4.75",
        "name": "175-PRGLTE-REPUBLICA"
    },
    {
        "ip": "10.36.4.8",
        "name": "108-PRGLTE-INC9-ROOT"
    },
    {
        "ip": "10.36.4.9",
        "name": "109-PRGLTE-INC8"
    }
]

export const RAJANT_PERFORMANCE = [
    {
        "ip": "10.36.2.112",
        "fecha": "2026-02-26 09:07:00",
        "server": "10.36.4.47",
        "latencia": 16.217,
        "bandwidth": "{\"Tx\": 2.757, \"Rx\": 2.691}"
    },
    {
        "ip": "10.36.2.113",
        "fecha": "2026-02-26 09:07:00",
        "server": "10.36.4.47",
        "latencia": 111.546,
        "bandwidth": "{\"Tx\": 0.857, \"Rx\": 0.789}"
    },
    {
        "ip": "10.36.2.115",
        "fecha": "2026-02-26 09:07:00",
        "server": "10.36.4.47",
        "latencia": 62.903,
        "bandwidth": "{\"Tx\": 0.39, \"Rx\": 0.361}"
    },
    {
        "ip": "10.36.2.119",
        "fecha": "2026-02-26 09:07:00",
        "server": "10.36.4.47",
        "latencia": 8.32,
        "bandwidth": "{\"Tx\": 8.117, \"Rx\": 8.005}"
    },
    {
        "ip": "10.36.2.117",
        "fecha": "2026-02-26 09:07:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.124",
        "fecha": "2026-02-26 09:07:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.113",
        "fecha": "2026-02-26 05:05:00",
        "server": "10.36.4.47",
        "latencia": 57.379,
        "bandwidth": "{\"Tx\": 1.067, \"Rx\": 0.902}"
    },
    {
        "ip": "10.36.2.115",
        "fecha": "2026-02-26 05:05:00",
        "server": "10.36.4.47",
        "latencia": 104.097,
        "bandwidth": "{\"Tx\": 0.725, \"Rx\": 0.648}"
    },
    {
        "ip": "10.36.2.119",
        "fecha": "2026-02-26 05:05:00",
        "server": "10.36.4.47",
        "latencia": 108.802,
        "bandwidth": "{\"Tx\": 1.142, \"Rx\": 1.06}"
    },
    {
        "ip": "10.36.2.112",
        "fecha": "2026-02-26 05:05:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.117",
        "fecha": "2026-02-26 05:05:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.124",
        "fecha": "2026-02-26 05:05:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.113",
        "fecha": "2026-02-26 01:05:00",
        "server": "10.36.4.47",
        "latencia": 13.648,
        "bandwidth": "{\"Tx\": 1.911, \"Rx\": 1.387}"
    },
    {
        "ip": "10.36.2.115",
        "fecha": "2026-02-26 01:05:00",
        "server": "10.36.4.47",
        "latencia": 9.722,
        "bandwidth": "{\"Tx\": 0.72, \"Rx\": 0.693}"
    },
    {
        "ip": "10.36.2.119",
        "fecha": "2026-02-26 01:05:00",
        "server": "10.36.4.47",
        "latencia": 57.7,
        "bandwidth": "{\"Tx\": 1.513, \"Rx\": 1.438}"
    },
    {
        "ip": "10.36.2.112",
        "fecha": "2026-02-26 01:05:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.117",
        "fecha": "2026-02-26 01:05:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.124",
        "fecha": "2026-02-26 01:05:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.4.60",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 9.09,
        "bandwidth": "{\"Tx\": 6.179, \"Rx\": 5.908}"
    },
    {
        "ip": "10.36.4.61",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 9.02,
        "bandwidth": "{\"Tx\": 36.904, \"Rx\": 35.922}"
    },
    {
        "ip": "10.36.4.62",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 20.914,
        "bandwidth": "{\"Tx\": 35.138, \"Rx\": 34.117}"
    },
    {
        "ip": "10.36.4.63",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 4.449,
        "bandwidth": "{\"Tx\": 19.972, \"Rx\": 17.979}"
    },
    {
        "ip": "10.36.4.64",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 4.956,
        "bandwidth": "{\"Tx\": 20.423, \"Rx\": 19.261}"
    },
    {
        "ip": "10.36.4.65",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 6.576,
        "bandwidth": "{\"Tx\": 17.444, \"Rx\": 15.871}"
    },
    {
        "ip": "10.36.4.66",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 5.053,
        "bandwidth": "{\"Tx\": 40.749, \"Rx\": 40.044}"
    },
    {
        "ip": "10.36.4.67",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 14.783,
        "bandwidth": "{\"Tx\": 56.584, \"Rx\": 55.291}"
    },
    {
        "ip": "10.36.4.68",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 11.054,
        "bandwidth": "{\"Tx\": 8.062, \"Rx\": 7.338}"
    },
    {
        "ip": "10.36.4.69",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 11.057,
        "bandwidth": "{\"Tx\": 71.874, \"Rx\": 71.154}"
    },
    {
        "ip": "10.36.4.70",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 6.491,
        "bandwidth": "{\"Tx\": 25.699, \"Rx\": 24.669}"
    },
    {
        "ip": "10.36.4.71",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 5.063,
        "bandwidth": "{\"Tx\": 24.802, \"Rx\": 24.341}"
    },
    {
        "ip": "10.36.4.72",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 98.945,
        "bandwidth": "{\"Tx\": 6.024, \"Rx\": 5.957}"
    },
    {
        "ip": "10.36.4.73",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 86.278,
        "bandwidth": "{\"Tx\": 1.957, \"Rx\": 1.789}"
    },
    {
        "ip": "10.36.4.74",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 10.767,
        "bandwidth": "{\"Tx\": 7.318, \"Rx\": 6.65}"
    },
    {
        "ip": "10.36.4.75",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 47.309,
        "bandwidth": "{\"Tx\": 1.13, \"Rx\": 1.08}"
    },
    {
        "ip": "10.36.4.14",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.4.1",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 12.095,
        "bandwidth": "{\"Tx\": 36.436, \"Rx\": 35.675}"
    },
    {
        "ip": "10.36.4.2",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 0.696,
        "bandwidth": "{\"Tx\": 76.275, \"Rx\": 75.264}"
    },
    {
        "ip": "10.36.4.3",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 11.715,
        "bandwidth": "{\"Tx\": 33.936, \"Rx\": 33.338}"
    },
    {
        "ip": "10.36.4.4",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 7,
        "bandwidth": "{\"Tx\": 33.758, \"Rx\": 33.162}"
    },
    {
        "ip": "10.36.4.5",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 4.034,
        "bandwidth": "{\"Tx\": 22.685, \"Rx\": 21.968}"
    },
    {
        "ip": "10.36.4.6",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 9.751,
        "bandwidth": "{\"Tx\": 50.827, \"Rx\": 50.089}"
    },
    {
        "ip": "10.36.4.7",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 20.997,
        "bandwidth": "{\"Tx\": 8.249, \"Rx\": 7.163}"
    },
    {
        "ip": "10.36.4.8",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 4.765,
        "bandwidth": "{\"Tx\": 32.021, \"Rx\": 31.032}"
    },
    {
        "ip": "10.36.4.9",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 10.555,
        "bandwidth": "{\"Tx\": 19.072, \"Rx\": 18.877}"
    },
    {
        "ip": "10.36.4.10",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 4.822,
        "bandwidth": "{\"Tx\": 19.597, \"Rx\": 19.154}"
    },
    {
        "ip": "10.36.4.11",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 29.915,
        "bandwidth": "{\"Tx\": 6.361, \"Rx\": 6.223}"
    },
    {
        "ip": "10.36.4.12",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 47.276,
        "bandwidth": "{\"Tx\": 2.668, \"Rx\": 2.53}"
    },
    {
        "ip": "10.36.4.13",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 5.651,
        "bandwidth": "{\"Tx\": 9.881, \"Rx\": 8.569}"
    },
    {
        "ip": "10.36.4.15",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 13.06,
        "bandwidth": "{\"Tx\": 8.203, \"Rx\": 8.093}"
    },
    {
        "ip": "10.36.4.16",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 11.292,
        "bandwidth": "{\"Tx\": 55.245, \"Rx\": 53.886}"
    },
    {
        "ip": "10.36.4.17",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 11.617,
        "bandwidth": "{\"Tx\": 42.407, \"Rx\": 41.098}"
    },
    {
        "ip": "10.36.4.18",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 7.99,
        "bandwidth": "{\"Tx\": 11.486, \"Rx\": 10.241}"
    },
    {
        "ip": "10.36.4.19",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 8.676,
        "bandwidth": "{\"Tx\": 48.93, \"Rx\": 48.043}"
    },
    {
        "ip": "10.36.4.20",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 15.622,
        "bandwidth": "{\"Tx\": 31.432, \"Rx\": 30.727}"
    },
    {
        "ip": "10.36.4.21",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 29.95,
        "bandwidth": "{\"Tx\": 19.791, \"Rx\": 18.785}"
    },
    {
        "ip": "10.36.4.22",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 12.517,
        "bandwidth": "{\"Tx\": 3.615, \"Rx\": 3.48}"
    },
    {
        "ip": "10.36.4.23",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 12.092,
        "bandwidth": "{\"Tx\": 2.636, \"Rx\": 2.522}"
    },
    {
        "ip": "10.36.4.24",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 23.77,
        "bandwidth": "{\"Tx\": 10.73, \"Rx\": 10.524}"
    },
    {
        "ip": "10.36.4.25",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 7.47,
        "bandwidth": "{\"Tx\": 6.39, \"Rx\": 6.261}"
    },
    {
        "ip": "10.36.4.27",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 57.865,
        "bandwidth": "{\"Tx\": 1.342, \"Rx\": 1.302}"
    },
    {
        "ip": "10.36.4.28",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 13.283,
        "bandwidth": "{\"Tx\": 1.833, \"Rx\": 1.785}"
    },
    {
        "ip": "10.36.4.29",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 103.146,
        "bandwidth": "{\"Tx\": 1.692, \"Rx\": 1.622}"
    },
    {
        "ip": "10.36.4.30",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 43.097,
        "bandwidth": "{\"Tx\": 1.107, \"Rx\": 1.045}"
    },
    {
        "ip": "10.36.4.31",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 47.107,
        "bandwidth": "{\"Tx\": 2.443, \"Rx\": 2.347}"
    },
    {
        "ip": "10.36.4.32",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 49.987,
        "bandwidth": "{\"Tx\": 2.091, \"Rx\": 2.013}"
    },
    {
        "ip": "10.36.4.33",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 13.27,
        "bandwidth": "{\"Tx\": 6.687, \"Rx\": 6.572}"
    },
    {
        "ip": "10.36.4.34",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 15.902,
        "bandwidth": "{\"Tx\": 3.928, \"Rx\": 3.813}"
    },
    {
        "ip": "10.36.4.35",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 44.527,
        "bandwidth": "{\"Tx\": 0.269, \"Rx\": 0.245}"
    },
    {
        "ip": "10.36.4.36",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 11.51,
        "bandwidth": "{\"Tx\": 2.339, \"Rx\": 2.263}"
    },
    {
        "ip": "10.36.4.37",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 10.602,
        "bandwidth": "{\"Tx\": 1.736, \"Rx\": 1.685}"
    },
    {
        "ip": "10.36.4.38",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 28.762,
        "bandwidth": "{\"Tx\": 1.105, \"Rx\": 1.018}"
    },
    {
        "ip": "10.36.4.39",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 52.82,
        "bandwidth": "{\"Tx\": 2.273, \"Rx\": 2.176}"
    },
    {
        "ip": "10.36.4.40",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 0.961,
        "bandwidth": "{\"Tx\": 545.74, \"Rx\": 544.863}"
    },
    {
        "ip": "10.36.4.41",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 6.796,
        "bandwidth": "{\"Tx\": 201.146, \"Rx\": 199.206}"
    },
    {
        "ip": "10.36.4.42",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 14.072,
        "bandwidth": "{\"Tx\": 35.026, \"Rx\": 34.397}"
    },
    {
        "ip": "10.36.4.43",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 1.195,
        "bandwidth": "{\"Tx\": 541.513, \"Rx\": 540.515}"
    },
    {
        "ip": "10.36.4.44",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 5.778,
        "bandwidth": "{\"Tx\": 32.635, \"Rx\": 31.447}"
    },
    {
        "ip": "10.36.4.45",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 6.565,
        "bandwidth": "{\"Tx\": 26.553, \"Rx\": 26.178}"
    },
    {
        "ip": "10.36.4.46",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 8.34,
        "bandwidth": "{\"Tx\": 24.696, \"Rx\": 23.918}"
    },
    {
        "ip": "10.36.4.48",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 8.071,
        "bandwidth": "{\"Tx\": 1.351, \"Rx\": 1.23}"
    },
    {
        "ip": "10.36.4.49",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 11.338,
        "bandwidth": "{\"Tx\": 42.821, \"Rx\": 41.83}"
    },
    {
        "ip": "10.36.4.50",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 4.68,
        "bandwidth": "{\"Tx\": 30.705, \"Rx\": 29.634}"
    },
    {
        "ip": "10.36.4.51",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 9.726,
        "bandwidth": "{\"Tx\": 59.328, \"Rx\": 58.09}"
    },
    {
        "ip": "10.36.4.52",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 6.74,
        "bandwidth": "{\"Tx\": 7.016, \"Rx\": 6.809}"
    },
    {
        "ip": "10.36.4.53",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 8.062,
        "bandwidth": "{\"Tx\": 3.666, \"Rx\": 3.45}"
    },
    {
        "ip": "10.36.4.54",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 4.501,
        "bandwidth": "{\"Tx\": 13.506, \"Rx\": 12.095}"
    },
    {
        "ip": "10.36.4.55",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 4.78,
        "bandwidth": "{\"Tx\": 31.856, \"Rx\": 30.637}"
    },
    {
        "ip": "10.36.4.56",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 11.96,
        "bandwidth": "{\"Tx\": 11.065, \"Rx\": 10.888}"
    },
    {
        "ip": "10.36.4.57",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 22.339,
        "bandwidth": "{\"Tx\": 17.297, \"Rx\": 17.121}"
    },
    {
        "ip": "10.36.4.58",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 5.286,
        "bandwidth": "{\"Tx\": 47.063, \"Rx\": 45.981}"
    },
    {
        "ip": "10.36.4.59",
        "fecha": "2026-02-25 22:38:00",
        "server": "10.36.4.47",
        "latencia": 21.616,
        "bandwidth": "{\"Tx\": 3.223, \"Rx\": 3.15}"
    },
    {
        "ip": "10.36.2.112",
        "fecha": "2026-02-25 21:07:00",
        "server": "10.36.4.47",
        "latencia": 171.185,
        "bandwidth": "{\"Tx\": 1.807, \"Rx\": 1.751}"
    },
    {
        "ip": "10.36.2.113",
        "fecha": "2026-02-25 21:07:00",
        "server": "10.36.4.47",
        "latencia": 127.246,
        "bandwidth": "{\"Tx\": 1.412, \"Rx\": 1.352}"
    },
    {
        "ip": "10.36.2.115",
        "fecha": "2026-02-25 21:07:00",
        "server": "10.36.4.47",
        "latencia": 25.705,
        "bandwidth": "{\"Tx\": 0.465, \"Rx\": 0.444}"
    },
    {
        "ip": "10.36.2.119",
        "fecha": "2026-02-25 21:07:00",
        "server": "10.36.4.47",
        "latencia": 11.13,
        "bandwidth": "{\"Tx\": 2.282, \"Rx\": 2.147}"
    },
    {
        "ip": "10.36.2.117",
        "fecha": "2026-02-25 21:07:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.124",
        "fecha": "2026-02-25 21:07:00",
        "server": "10.36.4.47",
        "latencia": -1,
        "bandwidth": "{\"Tx\": -1, \"Rx\": -1}"
    },
    {
        "ip": "10.36.2.112",
        "fecha": "2026-02-25 17:06:00",
        "server": "10.36.4.47",
        "latencia": 21.347,
        "bandwidth": "{\"Tx\": 1.324, \"Rx\": 1.193}"
    },
    {
        "ip": "10.36.2.113",
        "fecha": "2026-02-25 17:06:00",
        "server": "10.36.4.47",
        "latencia": 108.414,
        "bandwidth": "{\"Tx\": 1.317, \"Rx\": 1.225}"
    },
    {
        "ip": "10.36.2.115",
        "fecha": "2026-02-25 17:06:00",
        "server": "10.36.4.47",
        "latencia": 159.343,
        "bandwidth": "{\"Tx\": 0.482, \"Rx\": 0.315}"
    }
]

export const RAJANT_GPS = [
    {
        "latitud": 0,
        "longitud": 0,
        "altitud": 0,
        "ip": "10.36.2.136",
        "fecha": "2026-02-26 12:55:00",
        "name": "TT054-ME5(SPARROW)"
    },
    {
        "latitud": -1,
        "longitud": -1,
        "altitud": -1,
        "ip": "10.36.2.195",
        "fecha": "2026-02-26 12:55:00",
        "name": "MV096-JR3-2.4-CH-ONCE"
    },
    {
        "latitud": 30.9585,
        "longitud": -110.334,
        "altitud": 1570.7,
        "ip": "10.36.2.69",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT667-ME5(SPARROW)"
    },
    {
        "latitud": 30.9674,
        "longitud": -110.322,
        "altitud": 1758.8,
        "ip": "10.36.4.11",
        "fecha": "2026-02-26 12:55:00",
        "name": "111-LX5-PNT-VLDR"
    },
    {
        "latitud": 30.9554,
        "longitud": -110.318,
        "altitud": 1636.7,
        "ip": "10.36.4.19",
        "fecha": "2026-02-26 12:55:00",
        "name": "119-PRGLTE-OF.QLIX2-ROOT"
    },
    {
        "latitud": 30.9566,
        "longitud": -110.33,
        "altitud": 1624.5,
        "ip": "10.36.4.27",
        "fecha": "2026-02-26 12:55:00",
        "name": "127-LX5-ES027"
    },
    {
        "latitud": 30.956,
        "longitud": -110.332,
        "altitud": 1625.3,
        "ip": "10.36.4.34",
        "fecha": "2026-02-26 12:55:00",
        "name": "134-LX5-ES034"
    },
    {
        "latitud": 30.9709,
        "longitud": -110.339,
        "altitud": 1575,
        "ip": "10.36.4.42",
        "fecha": "2026-02-26 12:55:00",
        "name": "142-LX5-RAMPA-INC8-ROOT"
    },
    {
        "latitud": 30.9656,
        "longitud": -110.322,
        "altitud": 1735.7,
        "ip": "10.36.4.5",
        "fecha": "2026-02-26 12:55:00",
        "name": "105-PRGLTE-MIRADOR-ROOT"
    },
    {
        "latitud": 30.9682,
        "longitud": -110.362,
        "altitud": 1898.7,
        "ip": "10.36.4.57",
        "fecha": "2026-02-26 12:55:00",
        "name": "157-PRG-RAMPA-ASERRADERO"
    },
    {
        "latitud": 30.9481,
        "longitud": -110.324,
        "altitud": 1720.3,
        "ip": "10.36.4.64",
        "fecha": "2026-02-26 12:55:00",
        "name": "164-PRG-INC12-ROOT"
    },
    {
        "latitud": 30.9886,
        "longitud": -110.329,
        "altitud": 1697.6,
        "ip": "10.36.4.71",
        "fecha": "2026-02-26 12:55:00",
        "name": "171-PRGLTE-COMEDOR3-ROOT"
    },
    {
        "latitud": 30.966,
        "longitud": -110.347,
        "altitud": 1621.8,
        "ip": "10.36.2.131",
        "fecha": "2026-02-26 12:55:00",
        "name": "TT048-ME5(SPARROW)"
    },
    {
        "latitud": 30.9574,
        "longitud": -110.326,
        "altitud": 1584.8,
        "ip": "10.36.2.143",
        "fecha": "2026-02-26 12:55:00",
        "name": "MT036-HWK-FRONT LOADER"
    },
    {
        "latitud": 30.9567,
        "longitud": -110.327,
        "altitud": 1559.3,
        "ip": "10.36.2.53",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT651-ME5(SPARROW)"
    },
    {
        "latitud": 30.9627,
        "longitud": -110.32,
        "altitud": 1680.9,
        "ip": "10.36.2.73",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT671-ME5(SPARROW)"
    },
    {
        "latitud": 30.9837,
        "longitud": -110.325,
        "altitud": 1708.7,
        "ip": "10.36.4.14",
        "fecha": "2026-02-26 12:55:00",
        "name": "114-PRGLTE-EST-DEM-ROOT"
    },
    {
        "latitud": 30.9745,
        "longitud": -110.354,
        "altitud": 1816,
        "ip": "10.36.4.21",
        "fecha": "2026-02-26 12:55:00",
        "name": "121-PRGLTE-INC9-ROOT"
    },
    {
        "latitud": 30.9763,
        "longitud": -110.343,
        "altitud": 1719.3,
        "ip": "10.36.4.3",
        "fecha": "2026-02-26 12:55:00",
        "name": "103-LX5-DEM-QBLIX3-ROOT"
    },
    {
        "latitud": 30.9787,
        "longitud": -110.336,
        "altitud": 1669.2,
        "ip": "10.36.4.38",
        "fecha": "2026-02-26 12:55:00",
        "name": "138-LX5-ES038"
    },
    {
        "latitud": 30.9579,
        "longitud": -110.34,
        "altitud": 1720.1,
        "ip": "10.36.4.45",
        "fecha": "2026-02-26 12:55:00",
        "name": "145-PRGLTE-RAMPA-INC16-ROOT"
    },
    {
        "latitud": 30.962,
        "longitud": -110.333,
        "altitud": 1365.2,
        "ip": "10.36.4.52",
        "fecha": "2026-02-26 12:55:00",
        "name": "152-LX5-INC8-SITIO BOMBEO"
    },
    {
        "latitud": 30.9672,
        "longitud": -110.358,
        "altitud": 1816.1,
        "ip": "10.36.4.6",
        "fecha": "2026-02-26 12:55:00",
        "name": "106-PRGLTE-ESPLANADA-GLUYAS-ROOT"
    },
    {
        "latitud": 30.9836,
        "longitud": -110.345,
        "altitud": 1804,
        "ip": "10.36.4.67",
        "fecha": "2026-02-26 12:55:00",
        "name": "167-PRGLTE-INC9-ROOT"
    },
    {
        "latitud": 30.9571,
        "longitud": -110.314,
        "altitud": 1706.8,
        "ip": "10.36.4.74",
        "fecha": "2026-02-26 12:55:00",
        "name": "174-PRGLTE-INC12"
    },
    {
        "latitud": 0,
        "longitud": 0,
        "altitud": 0,
        "ip": "10.36.2.134",
        "fecha": "2026-02-26 12:55:00",
        "name": "TT051-ME5(SPARROW)"
    },
    {
        "latitud": 30.975,
        "longitud": -110.326,
        "altitud": 1649.1,
        "ip": "10.36.2.146",
        "fecha": "2026-02-26 12:55:00",
        "name": "MT062-OSP-FRONT LOADER"
    },
    {
        "latitud": 30.9969,
        "longitud": -110.327,
        "altitud": 1627.1,
        "ip": "10.36.2.65",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT663-ME5(SPARROW)"
    },
    {
        "latitud": 30.9627,
        "longitud": -110.368,
        "altitud": 1961.1,
        "ip": "10.36.4.1",
        "fecha": "2026-02-26 12:55:00",
        "name": "101-LX5-RANCH-SUR1-ROOT"
    },
    {
        "latitud": 30.965,
        "longitud": -110.36,
        "altitud": 1861.7,
        "ip": "10.36.4.17",
        "fecha": "2026-02-26 12:55:00",
        "name": "117-PRGLTE-INC9-ROOT"
    },
    {
        "latitud": 30.9788,
        "longitud": -110.345,
        "altitud": 1771.3,
        "ip": "10.36.4.24",
        "fecha": "2026-02-26 12:55:00",
        "name": "124-LX5-ES024"
    },
    {
        "latitud": -1,
        "longitud": -1,
        "altitud": -1,
        "ip": "10.36.4.32",
        "fecha": "2026-02-26 12:55:00",
        "name": "132-LX5-ES032"
    },
    {
        "latitud": 30.9694,
        "longitud": -110.324,
        "altitud": 1808.9,
        "ip": "10.36.4.40",
        "fecha": "2026-02-26 12:55:00",
        "name": "140-PRG-TNQS-ROOT"
    },
    {
        "latitud": 30.9348,
        "longitud": -110.372,
        "altitud": 1824.5,
        "ip": "10.36.4.48",
        "fecha": "2026-02-26 12:55:00",
        "name": "148-PRG-VAC-MX-TEPE"
    },
    {
        "latitud": 30.9735,
        "longitud": -110.332,
        "altitud": 1517.2,
        "ip": "10.36.4.55",
        "fecha": "2026-02-26 12:55:00",
        "name": "155-PRG-INC8-CURVA-LLANTAS-ROOT"
    },
    {
        "latitud": 30.9643,
        "longitud": -110.323,
        "altitud": 1683,
        "ip": "10.36.4.62",
        "fecha": "2026-02-26 12:55:00",
        "name": "162-PRG-INC11-ROOT"
    },
    {
        "latitud": 30.9642,
        "longitud": -110.346,
        "altitud": 1676.1,
        "ip": "10.36.4.7",
        "fecha": "2026-02-26 12:55:00",
        "name": "107-PRG-CARCAMO-ROOT"
    },
    {
        "latitud": 30.9661,
        "longitud": -110.329,
        "altitud": 1502.6,
        "ip": "10.36.4.9",
        "fecha": "2026-02-26 12:55:00",
        "name": "109-PRGLTE-INC8"
    },
    {
        "latitud": 30.9673,
        "longitud": -110.324,
        "altitud": 1729.9,
        "ip": "10.36.2.137",
        "fecha": "2026-02-26 12:55:00",
        "name": "TT056-ME5(SPARROW)"
    },
    {
        "latitud": 30.9441,
        "longitud": -110.358,
        "altitud": 1729.6,
        "ip": "10.36.2.34",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT632-ME5(SPARROW)"
    },
    {
        "latitud": 30.9676,
        "longitud": -110.348,
        "altitud": 1649.6,
        "ip": "10.36.2.70",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT668-ME5(SPARROW)"
    },
    {
        "latitud": 30.9777,
        "longitud": -110.325,
        "altitud": 1726.1,
        "ip": "10.36.4.12",
        "fecha": "2026-02-26 12:55:00",
        "name": "112-PRG-RAMPA-PR3"
    },
    {
        "latitud": 30.9548,
        "longitud": -110.337,
        "altitud": 1803.3,
        "ip": "10.36.4.2",
        "fecha": "2026-02-26 12:55:00",
        "name": "102-PRG-TORRE CONTROL-ROOT"
    },
    {
        "latitud": 30.9759,
        "longitud": -110.328,
        "altitud": 1650.8,
        "ip": "10.36.4.28",
        "fecha": "2026-02-26 12:55:00",
        "name": "128-LX5-ES028"
    },
    {
        "latitud": 30.9575,
        "longitud": -110.326,
        "altitud": 1593,
        "ip": "10.36.4.35",
        "fecha": "2026-02-26 12:55:00",
        "name": "135-LX5-ES035"
    },
    {
        "latitud": 30.9978,
        "longitud": -110.329,
        "altitud": 1674.4,
        "ip": "10.36.4.43",
        "fecha": "2026-02-26 12:55:00",
        "name": "143-PRG-SUPCIA-MNT-ROOT"
    },
    {
        "latitud": 30.9541,
        "longitud": -110.334,
        "altitud": 1705.1,
        "ip": "10.36.4.50",
        "fecha": "2026-02-26 12:55:00",
        "name": "150-PRGLTE-INC-16-ROOT"
    },
    {
        "latitud": 30.9489,
        "longitud": -110.321,
        "altitud": 1664.6,
        "ip": "10.36.4.58",
        "fecha": "2026-02-26 12:55:00",
        "name": "158-PRG-INC12-ROOT"
    },
    {
        "latitud": 30.95,
        "longitud": -110.332,
        "altitud": 1757.8,
        "ip": "10.36.4.65",
        "fecha": "2026-02-26 12:55:00",
        "name": "165-PRG-INC12-QLIX2-ROOT"
    },
    {
        "latitud": 30.9403,
        "longitud": -110.361,
        "altitud": 1783.9,
        "ip": "10.36.4.72",
        "fecha": "2026-02-26 12:55:00",
        "name": "172-PRGLTE-RUTA-MX"
    },
    {
        "latitud": 30.9648,
        "longitud": -110.357,
        "altitud": 1773.6,
        "ip": "10.36.2.132",
        "fecha": "2026-02-26 12:55:00",
        "name": "TT049-ME5(SPARROW)"
    },
    {
        "latitud": 30.9979,
        "longitud": -110.327,
        "altitud": 1729.4,
        "ip": "10.36.2.144",
        "fecha": "2026-02-26 12:55:00",
        "name": "MT059-OSP-FRONT LOADER"
    },
    {
        "latitud": 30.9578,
        "longitud": -110.338,
        "altitud": 1614.4,
        "ip": "10.36.2.54",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT652-ME5(SPARROW)"
    },
    {
        "latitud": 30.9663,
        "longitud": -110.336,
        "altitud": 1197.7,
        "ip": "10.36.2.84",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT682-ME5(SPARROW)"
    },
    {
        "latitud": 30.9704,
        "longitud": -110.337,
        "altitud": 1473.1,
        "ip": "10.36.4.15",
        "fecha": "2026-02-26 12:55:00",
        "name": "115-LX5-INC8-ALTO"
    },
    {
        "latitud": 30.9387,
        "longitud": -110.368,
        "altitud": 1827.2,
        "ip": "10.36.4.22",
        "fecha": "2026-02-26 12:55:00",
        "name": "122-PRGLTE-VAC-MX-TEPE"
    },
    {
        "latitud": 30.9515,
        "longitud": -110.325,
        "altitud": 1590.7,
        "ip": "10.36.4.30",
        "fecha": "2026-02-26 12:55:00",
        "name": "130-LX5-ES030"
    },
    {
        "latitud": 30.9518,
        "longitud": -110.33,
        "altitud": 1637.7,
        "ip": "10.36.4.39",
        "fecha": "2026-02-26 12:55:00",
        "name": "139-LX5-ES039"
    },
    {
        "latitud": 30.9765,
        "longitud": -110.354,
        "altitud": 1833,
        "ip": "10.36.4.46",
        "fecha": "2026-02-26 12:55:00",
        "name": "146-LX5-INC9-1-ROOT"
    },
    {
        "latitud": 30.9748,
        "longitud": -110.325,
        "altitud": 1705.4,
        "ip": "10.36.4.53",
        "fecha": "2026-02-26 12:55:00",
        "name": "153-LX5-INC8-3"
    },
    {
        "latitud": 30.9396,
        "longitud": -110.349,
        "altitud": 1747,
        "ip": "10.36.4.60",
        "fecha": "2026-02-26 12:55:00",
        "name": "160-PRG-VAC-MX-3"
    },
    {
        "latitud": 30.9639,
        "longitud": -110.338,
        "altitud": 1364,
        "ip": "10.36.4.68",
        "fecha": "2026-02-26 12:55:00",
        "name": "168-PRGLTE-INC8-BAJO"
    },
    {
        "latitud": 30.9661,
        "longitud": -110.315,
        "altitud": 1737.7,
        "ip": "10.36.4.75",
        "fecha": "2026-02-26 12:55:00",
        "name": "175-PRGLTE-REPUBLICA"
    },
    {
        "latitud": 30.9776,
        "longitud": -110.336,
        "altitud": 1620.5,
        "ip": "10.36.2.135",
        "fecha": "2026-02-26 12:55:00",
        "name": "TT052-ME5(SPARROW)"
    },
    {
        "latitud": 30.9702,
        "longitud": -110.352,
        "altitud": 1698.6,
        "ip": "10.36.2.147",
        "fecha": "2026-02-26 12:55:00",
        "name": "MT088-HWK-FRONT LOADER"
    },
    {
        "latitud": 30.997,
        "longitud": -110.328,
        "altitud": 1645.6,
        "ip": "10.36.2.68",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT666-ME5(SPARROW)"
    },
    {
        "latitud": 30.9626,
        "longitud": -110.32,
        "altitud": 1723.4,
        "ip": "10.36.4.10",
        "fecha": "2026-02-26 12:55:00",
        "name": "110-PRGLTE-INC12-ROOT"
    },
    {
        "latitud": 30.9816,
        "longitud": -110.338,
        "altitud": 1751.8,
        "ip": "10.36.4.18",
        "fecha": "2026-02-26 12:55:00",
        "name": "118-PRGLTE-INC9-ROOT"
    },
    {
        "latitud": 30.9668,
        "longitud": -110.337,
        "altitud": 1235.4,
        "ip": "10.36.4.25",
        "fecha": "2026-02-26 12:55:00",
        "name": "125-LX5-ES025"
    },
    {
        "latitud": 30.9815,
        "longitud": -110.329,
        "altitud": 1638.6,
        "ip": "10.36.4.33",
        "fecha": "2026-02-26 12:55:00",
        "name": "133-LX5-ES033"
    },
    {
        "latitud": 30.9857,
        "longitud": -110.336,
        "altitud": 1844.7,
        "ip": "10.36.4.41",
        "fecha": "2026-02-26 12:55:00",
        "name": "141-PRG-BUENA-V-ROOT"
    },
    {
        "latitud": 30.9476,
        "longitud": -110.333,
        "altitud": 1773.8,
        "ip": "10.36.4.49",
        "fecha": "2026-02-26 12:55:00",
        "name": "149-PRGLTE-CURVA-VAC-MX-ROOT"
    },
    {
        "latitud": 30.9399,
        "longitud": -110.336,
        "altitud": 1774.5,
        "ip": "10.36.4.56",
        "fecha": "2026-02-26 12:55:00",
        "name": "156-PRG-VAC-MX -2"
    },
    {
        "latitud": 30.9597,
        "longitud": -110.316,
        "altitud": 1706.3,
        "ip": "10.36.4.63",
        "fecha": "2026-02-26 12:55:00",
        "name": "163-PRG-TALLERES-VIEJOS-ROOT "
    },
    {
        "latitud": 30.9848,
        "longitud": -110.331,
        "altitud": 1700.5,
        "ip": "10.36.4.70",
        "fecha": "2026-02-26 12:55:00",
        "name": "170-PRG-RAMPA-DEMOC-N-ROOT"
    },
    {
        "latitud": 30.9472,
        "longitud": -110.321,
        "altitud": 1645.5,
        "ip": "10.36.2.14",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT612-ME5(SPARROW)"
    },
    {
        "latitud": 30.9555,
        "longitud": -110.334,
        "altitud": 1604.2,
        "ip": "10.36.2.4",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT602-ME5(SPARROW)"
    },
    {
        "latitud": 30.9714,
        "longitud": -110.349,
        "altitud": 1662.1,
        "ip": "10.36.2.71",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT669-ME5(SPARROW)"
    },
    {
        "latitud": 30.9832,
        "longitud": -110.333,
        "altitud": 1723,
        "ip": "10.36.4.13",
        "fecha": "2026-02-26 12:55:00",
        "name": "113-PRGLTE-DEM-ROOT"
    },
    {
        "latitud": 30.9586,
        "longitud": -110.339,
        "altitud": 1665.8,
        "ip": "10.36.4.20",
        "fecha": "2026-02-26 12:55:00",
        "name": "120-LX5-INC11-4-ROOT"
    },
    {
        "latitud": 30.9575,
        "longitud": -110.322,
        "altitud": 1584.7,
        "ip": "10.36.4.29",
        "fecha": "2026-02-26 12:55:00",
        "name": "129-LX5-ES029"
    },
    {
        "latitud": 30.9645,
        "longitud": -110.333,
        "altitud": 1314.3,
        "ip": "10.36.4.36",
        "fecha": "2026-02-26 12:55:00",
        "name": "136-HNT-ES036"
    },
    {
        "latitud": 30.9481,
        "longitud": -110.317,
        "altitud": 1673.4,
        "ip": "10.36.4.44",
        "fecha": "2026-02-26 12:55:00",
        "name": "144-PRG-INC-12-ROOT"
    },
    {
        "latitud": 30.9721,
        "longitud": -110.363,
        "altitud": 1921.4,
        "ip": "10.36.4.51",
        "fecha": "2026-02-26 12:55:00",
        "name": "151-PRG-INC9-RAMPA-ASERRADERO-ROOT"
    },
    {
        "latitud": 30.9666,
        "longitud": -110.33,
        "altitud": 1464,
        "ip": "10.36.4.59",
        "fecha": "2026-02-26 12:55:00",
        "name": "159-PRG-INC11"
    },
    {
        "latitud": 30.9488,
        "longitud": -110.328,
        "altitud": 1706.1,
        "ip": "10.36.4.66",
        "fecha": "2026-02-26 12:55:00",
        "name": "166-PRGLTE-INC12-ROOT"
    },
    {
        "latitud": 30.9742,
        "longitud": -110.346,
        "altitud": 1685.4,
        "ip": "10.36.4.73",
        "fecha": "2026-02-26 12:55:00",
        "name": "173-PRGLTE-INC9"
    },
    {
        "latitud": 30.9684,
        "longitud": -110.356,
        "altitud": 1753.1,
        "ip": "10.36.2.133",
        "fecha": "2026-02-26 12:55:00",
        "name": "TT050-ME5(SPARROW)"
    },
    {
        "latitud": 30.9664,
        "longitud": -110.335,
        "altitud": 1232.8,
        "ip": "10.36.2.145",
        "fecha": "2026-02-26 12:55:00",
        "name": "MT061-HWK-FRONT LOADER"
    },
    {
        "latitud": 30.9575,
        "longitud": -110.329,
        "altitud": 1548.5,
        "ip": "10.36.2.58",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT656-ME5(SPARROW)"
    },
    {
        "latitud": 30.974,
        "longitud": -110.331,
        "altitud": 1474.1,
        "ip": "10.36.2.9",
        "fecha": "2026-02-26 12:55:00",
        "name": "DT607-ME5(SPARROW)"
    },
    {
        "latitud": 30.9662,
        "longitud": -110.353,
        "altitud": 1753.1,
        "ip": "10.36.4.16",
        "fecha": "2026-02-26 12:55:00",
        "name": "116-PRGLTE-PR2-OESTE-ROOT"
    },
    {
        "latitud": 30.9784,
        "longitud": -110.33,
        "altitud": 1628.1,
        "ip": "10.36.4.23",
        "fecha": "2026-02-26 12:55:00",
        "name": "123-LX5-ES023"
    },
    {
        "latitud": 30.9602,
        "longitud": -110.322,
        "altitud": 1612.6,
        "ip": "10.36.4.31",
        "fecha": "2026-02-26 12:55:00",
        "name": "131-LX5-ES031"
    },
    {
        "latitud": 30.9668,
        "longitud": -110.343,
        "altitud": 1474.1,
        "ip": "10.36.4.4",
        "fecha": "2026-02-26 12:55:00",
        "name": "104-PRG-INC8-ROOT"
    },
    {
        "latitud": 30.9678,
        "longitud": -110.35,
        "altitud": 1695.3,
        "ip": "10.36.4.47",
        "fecha": "2026-02-26 12:55:00",
        "name": "147-PRG-PR2-MASTER-ROOT"
    },
    {
        "latitud": 30.9668,
        "longitud": -110.328,
        "altitud": 1608.4,
        "ip": "10.36.4.54",
        "fecha": "2026-02-26 12:55:00",
        "name": "154-PRG-INC11-RPA-QBLIX3-ROOT"
    },
    {
        "latitud": 30.9815,
        "longitud": -110.333,
        "altitud": 1673.1,
        "ip": "10.36.4.61",
        "fecha": "2026-02-26 12:55:00",
        "name": "161-PRG-INC9-ROOT"
    },
    {
        "latitud": 30.9786,
        "longitud": -110.349,
        "altitud": 1786.7,
        "ip": "10.36.4.69",
        "fecha": "2026-02-26 12:55:00",
        "name": "169-PRGLTE-INC9-ROOT"
    },
    {
        "latitud": 30.975,
        "longitud": -110.348,
        "altitud": 1773.5,
        "ip": "10.36.4.8",
        "fecha": "2026-02-26 12:55:00",
        "name": "108-PRGLTE-INC9-ROOT"
    }
]

export const ICON_IMGS: any = {
    "perforadora": 'iconoPerforadora',
    "pala": 'iconoPala',
    "camion": 'iconoCamion',
    "camion lte": 'iconoCamion',
    "cargador frontal": 'iconoCargadorFrontal',
    "solar trailer": 'iconoSolarTrailer',
    "ap movil": 'iconoSolarTrailer',
    "ap fijo": 'iconoSolarTrailer',
    "pipa agua": 'iconoPipaAgua',
    "tractor": 'iconoCamion',
}